import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltipFixed]',
})
export class TooltipFixedDirective {

  private originalTooltip!: HTMLElement | null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onEnter() {
    const tooltip = this.el.nativeElement.querySelector('.tooltip-text');
    if (!tooltip) return;

    this.originalTooltip = tooltip;

    // move tooltip OUT of the table required for Safari/Firefox
    this.renderer.appendChild(document.body, tooltip);

    // Make it measurable
    this.renderer.setStyle(tooltip, 'position', 'fixed');
    this.renderer.setStyle(tooltip, 'left', '-9999px');
    this.renderer.setStyle(tooltip, 'top', '-9999px');
    this.renderer.setStyle(tooltip, 'visibility', 'hidden');
    this.renderer.setStyle(tooltip, 'opacity', '0');
    this.renderer.setStyle(tooltip, 'display', 'block');

    const rect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    let left = rect.left + rect.width / 2 - tooltipRect.width / 2;
    let top = rect.top - tooltipRect.height - 12;

    // Prevent right overflow
    const viewportWidth = window.innerWidth;
    if (left + tooltipRect.width > viewportWidth - 10) {
      left = viewportWidth - tooltipRect.width - 10;
    }

    // Prevent left overflow
    if (left < 10) {
      left = 10;
    }

    // Prevent tooltip from going off top
    if (top < 10) {
      top = rect.bottom + 12; // show below element instead
      tooltip.classList.add('tooltip-below');
    } else {
      tooltip.classList.remove('tooltip-below');
    }

    // Apply final styles
    this.renderer.setStyle(tooltip, 'left', `${left}px`);
    this.renderer.setStyle(tooltip, 'top', `${top}px`);
    this.renderer.setStyle(tooltip, 'visibility', 'visible');
    this.renderer.setStyle(tooltip, 'opacity', '1');
    this.renderer.setStyle(tooltip, 'z-index', '9999');
  }

  @HostListener('mouseleave')
  onLeave() {
    const tooltip = this.originalTooltip;
    if (!tooltip) return;

    // Hide tooltip
    this.renderer.setStyle(tooltip, 'visibility', 'hidden');
    this.renderer.setStyle(tooltip, 'opacity', '0');
    this.renderer.setStyle(tooltip, 'left', '-9999px');
    this.renderer.removeStyle(tooltip, 'display');

    //Move tooltip back to its original container
    this.renderer.appendChild(this.el.nativeElement, tooltip);
  }
}
